import { render, staticRenderFns } from "./v-left-card1.vue?vue&type=template&id=79c56b5a&scoped=true"
import script from "./v-left-card1.vue?vue&type=script&lang=js"
export * from "./v-left-card1.vue?vue&type=script&lang=js"
import style0 from "./v-left-card1.vue?vue&type=style&index=0&id=79c56b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c56b5a",
  null
  
)

export default component.exports